import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getPrenom } from '../../tools/fonctions';
import { isMobile } from 'react-device-detect';
import { navbarColor } from '../../tools/colors';

import { db } from '../../config/fbConfig';
import { collection, query, where, getDocs } from 'firebase/firestore';

const Navbar = () => {
  const [autorisation, setAutorisation] = useState('');
  const [nomSecteur, setNomSecteur] = useState('');
  const [nomAgence, setNomAgence] = useState('');

  const isAuth = useSelector(state => state.auth.auth);

  useEffect(() => {
    const loadAutorisations = async () => {
      if (!window.localStorage.email) return;

      try {
        const q = query(
          collection(db, 'autorisations'),
          where('utilisateur', '==', window.localStorage.email)
        );

        const snapshot = await getDocs(q);

        snapshot.forEach(doc => {
          const data = doc.data();

          setAutorisation(data.autorisation);
          setNomSecteur(data.Secteur);
          setNomAgence(data.Agence);

          window.localStorage.setItem('Autorisation', data.autorisation);

          if (data.autorisation === 'National') {
            window.localStorage.removeItem('Secteur');
            window.localStorage.removeItem('Agence');
          } else if (data.autorisation === 'Secteur') {
            window.localStorage.setItem('Secteur', data.Secteur);
            window.localStorage.removeItem('Agence');
          } else if (data.autorisation === 'Agence') {
            window.localStorage.setItem('Secteur', data.Secteur);
            window.localStorage.setItem('Agence', data.Agence);
          }
        });
      } catch (err) {
        console.error('Erreur chargement autorisations', err);
      }
    };

    loadAutorisations();
  }, []);

  const renderAutorisation = () => {
    if (!autorisation || !isAuth) return null;

    if (autorisation === 'National') return autorisation;
    if (autorisation === 'Secteur') return `${autorisation} ${nomSecteur}`;
    if (autorisation === 'Agence') return `${autorisation} ${nomAgence}`;

    return null;
  };

  return (
    <nav
      className="navbar navbar-expand-sm sticky-top"
      style={{ display: 'block', backgroundColor: navbarColor }}
    >
      <div className="d-flex">
        <a
          href="/"
          className="navbar-text mr-auto"
          style={{ fontSize: '20px', color: 'white' }}
        >
          Bonjour {isAuth ? getPrenom() : null},{' '}
          {isMobile ? (
            <p className="mb-0">{renderAutorisation()}</p>
          ) : (
            renderAutorisation()
          )}
        </a>

        <a href="https://www.orencash.fr/" className="navbar-brand">
          <img
            src={require('../img/logo-OEC.png')}
            alt="Logo OEC"
            style={{
              width: '100px',
              position: 'absolute',
              top: '10px',
              right: '10px'
            }}
          />
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
